import { transformSearch } from "@/api/helper";
import { queryOptions } from "@tanstack/react-query";
import { z } from "zod";
import userAuditLogService from "../services/user-audit-log-service";

export const UserAuditLogParams = z.object({
	search: z.string().optional(),
	page: z.number().nullable().optional(),
	per_page: z.number().optional(),
});

export const userAuditLogsQueryOptions = (search?: z.infer<typeof UserAuditLogParams>) => {
	return queryOptions({
		queryKey: ["user-audit-logs", search],
		queryFn: () => userAuditLogService.list(transformSearch(search, ["search"])),
	});
};
